import {BrowserAgent} from '@newrelic/browser-agent/loaders/browser-agent';

type BrowserAgentConfig = {
  accountId: string | undefined;
  agentId: string | undefined;
  applicationId: string | undefined;
  licenseKey: string | undefined;
  trustKey: string | undefined;
};

type ResolvedBrowserAgentConfig = {
  [Key in keyof BrowserAgentConfig]: string;
};

const browserAgentConfig: BrowserAgentConfig = {
  accountId: import.meta.env.VITE_NEW_RELIC_BROWSER_ACCOUNT_ID as
    | string
    | undefined,
  agentId: import.meta.env.VITE_NEW_RELIC_BROWSER_AGENT_ID as
    | string
    | undefined,
  applicationId: import.meta.env.VITE_NEW_RELIC_BROWSER_APPLICATION_ID as
    | string
    | undefined,
  licenseKey: import.meta.env.VITE_NEW_RELIC_BROWSER_LICENSE_KEY as
    | string
    | undefined,
  trustKey: import.meta.env.VITE_NEW_RELIC_BROWSER_TRUST_KEY as
    | string
    | undefined,
};

const beacon =
  (import.meta.env.VITE_NEW_RELIC_BROWSER_BEACON as string | undefined) ??
  'bam.eu01.nr-data.net';

const hasBrowserAgentConfig = (
  config: BrowserAgentConfig,
): config is ResolvedBrowserAgentConfig => Object.values(config).every(Boolean);

const TELEMETRY_ENVIRONMENTS: Record<string, string> = {
  develop: 'preprod',
  production: 'production',
  staging: 'staging',
  test: 'qa',
};

const telemetryEnvironment =
  TELEMETRY_ENVIRONMENTS[import.meta.env.VITE_ENV as string];

if (!hasBrowserAgentConfig(browserAgentConfig)) {
  if (import.meta.env.VITE_ENV === 'production') {
    throw new Error('Missing New Relic Browser production configuration');
  }
} else {
  const browserAgent = new BrowserAgent({
    init: {
      ajax: {
        deny_list: [beacon],
      },
      distributed_tracing: {
        allowed_origins: [],
        cors_use_newrelic_header: false,
        cors_use_tracecontext_headers: false,
        enabled: true,
        exclude_newrelic_header: false,
      },
      privacy: {
        cookies_enabled: true,
      },
    },
    info: {
      applicationID: browserAgentConfig.applicationId,
      beacon,
      errorBeacon: beacon,
      licenseKey: browserAgentConfig.licenseKey,
      sa: 1,
    },
    loader_config: {
      accountID: browserAgentConfig.accountId,
      agentID: browserAgentConfig.agentId,
      applicationID: browserAgentConfig.applicationId,
      licenseKey: browserAgentConfig.licenseKey,
      trustKey: browserAgentConfig.trustKey,
    },
  });

  if (telemetryEnvironment) {
    browserAgent.setCustomAttribute('env', telemetryEnvironment);
  }
}
